// update state
const setActionMessage = (payload) => {
    return {
        type: "ACTIONMESSAGE",
        payload
    }
}

export default setActionMessage;


// WEBPACK FOOTER //
// ./src/actions/setActionMessage.js